
import InnerPageTitle from '../components/Shared/InnerPageTitle/index.vue'

export default {
  components: {
    InnerPageTitle,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      loading: false,
    }
  },
  methods: {
    async SEND_TO_LOGIN(e) {
      e.preventDefault()
      if (this.loading) return
      this.loading = true
      this.alertBox = await this.$store.dispatch(
        'user/SEND_TO_ADMIN_LOGIN',
        this.form
      )
      if (this.alertBox.variant === 'success') {
        if (this.fast) return this.$emit('login:success')
        this.$router.push(this.localePath('/'))
      }
      this.loading = false
    },
  },
}
